module.exports = __webpack_public_path__ + "static/assets/911ef52fdb429b1c3e80a364a1f17d7f.png";